export const SIZES = {
  'S': 's',
  'M': 'm',
  'L': 'l',
  'XL': 'xl',
  '2XL': '2xl',
  '3XL': '3xl',
  '4XL': '4xl',
} as const;
